module.exports = __webpack_public_path__ + "static/media/welcome-audio-articles.9fc5dcaf.svg";